import { useEffect } from "react";
import { DadosContainerDefault } from "../../components/Styles";
import QuadrosKanban from "../../components/QuadrosKanban";

function KanbanPage() {
  useEffect(() => {
    document.title = 'Quadro Kanban | Gesttor'
  })
  return (
    <DadosContainerDefault>
      <QuadrosKanban />
    </DadosContainerDefault>
  );
}

export default KanbanPage;